import React, { useState, useEffect } from 'react';
import Container from '@mui/material/Container';
import Grid from '@mui/material/Grid'; // Grid version 1
import OrariMesse from '../components/OrariMesse';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CardHeader from '@mui/material/CardHeader';
import Avatar from '@mui/material/Avatar';
import red from '@mui/material/colors/red';

import Typography from '@mui/material/Typography';
import EventAvailableIcon from '@mui/icons-material/EventAvailable';

const today = new Date();
let tomorrow = new Date();
tomorrow.setDate(today.getDate() + 1)

const DRIVE_FOLDER_ID = '1-rOuR5PeJBJVmJgttv96y5PY8wy-Xkdb';
const API_KEY = process.env.REACT_APP_GOOGLE_API_KEY;

function Home() {
  const [programmiUrls, setProgrammiUrls] = useState([])
  const [driveError, setDriveError] = useState('')

  useEffect(() => {
    const fetchImages = async () => {
      if (!API_KEY) {
        setDriveError('Configurazione Google Drive non trovata (chiave API mancante).');
        return;
      }

      try {
        const res = await fetch(
          `https://www.googleapis.com/drive/v3/files?q='${DRIVE_FOLDER_ID}'+in+parents+and+mimeType+contains+'image/'&fields=files(id,name)&orderBy=name&key=${API_KEY}`
        );
        if (!res.ok) {
          const body = await res.text();
          try {
            const parsed = JSON.parse(body);
            const reason = parsed?.error?.details?.[0]?.reason;
            if (reason === 'API_KEY_HTTP_REFERRER_BLOCKED') {
              setDriveError('Google API key bloccata per dominio. Aggiungi localhost e dominio del sito nei referrer consentiti.');
              return;
            }
          } catch (_parseErr) {
            // Keep the generic error path below if response body is not JSON.
          }
          throw new Error(`Drive API ${res.status}: ${body}`);
        }
        const data = await res.json();
        if (data.files) {
          const urls = data.files.map(f => `https://lh3.googleusercontent.com/d/${f.id}`);
          setProgrammiUrls(urls);
          setDriveError('');
        } else {
          setDriveError('Nessuna immagine trovata nella cartella Drive.');
        }
      } catch (err) {
        console.error('Errore caricamento immagini Drive', err);
        setDriveError('Impossibile caricare i file da Drive. Verifica API key e restrizioni dominio.');
      }
    };
    fetchImages();
  }, []);


  const programmiImgs = programmiUrls.map( url => <img key={url} src={url} width="100%" alt={url}></img> )
  return (
    <Container className="home-page-cnt" maxWidth={false}>
      <Grid container spacing={2}>
        <Grid item  xs={12} md={10}>
          <img src="/images/subheader.jpg" width="100%" alt="chiesa"></img>
        </Grid>
        <Grid item xs={12} md={2}>
          <OrariMesse date={today}></OrariMesse>
          <OrariMesse date={tomorrow}></OrariMesse>
          <Card>
            <CardHeader
              avatar={
                <Avatar sx={{ bgcolor: red[500] }} aria-label="recipe">
                  <EventAvailableIcon/>
                </Avatar>
              }
              titleTypographyProps={{variant:'h6' }}
              title="Tutti i martedì del mese"
            />
            <CardContent>
              <Typography variant="body2" color="text.secondary">

                Dopo la messa delle 17,30 <b>adorazione eucaristica</b>
              </Typography>
            </CardContent>
          </Card>
          <br></br>
          <Card>
            <CardHeader
              avatar={
                <Avatar sx={{ bgcolor: red[500] }} aria-label="recipe">
                  <EventAvailableIcon/>
                </Avatar>
              }
              titleTypographyProps={{variant:'h6' }}
              title="Ogni 2° e 4° mercoledì del mese"
            />
            <CardContent>
              <Typography variant="body2" color="text.secondary">
              Ore 20,00 <b>adorazione eucaristica</b>
              </Typography>
            </CardContent>
          </Card>
        </Grid>
      </Grid>
      {programmiImgs}
      {driveError ? (
        <Typography sx={{ mt: 2 }} color="error">
          {driveError}
        </Typography>
      ) : null}
    </Container>
  );
};
  
export default Home;